import { createWebHistory, createRouter } from "vue-router";

import StandardLayout from "../layouts/StandardLayout.vue";
import HomePage from "../pages/Home.vue";

const routes = [
  {
    path: "/",
    component: StandardLayout,
    children: [
      { path: "", name: "Home", component: HomePage },
      {
        path: "/SoftOne",
        name: "SoftOne",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import("../pages/SoftOne.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { top: 0 };
    }
  },
});

export default router;
